import { api } from "@/configs";
import { defineStore } from "pinia";
import { apiUrls } from "@/constants";

import { notification } from "ant-design-vue";
import {reloadMedia} from "@/utils/media";

export const useMediaStore = defineStore("media", {

    state: () => {
        return {
            media: []
        };
    },
    actions: {
        async fetchMedia() {
            try {
                const response = await api.get(apiUrls.media);
                this.media = response?.data?.data ?? [];
                return true;
            } catch (error) {
                this.media = [];
                return false;
            }
        },
        async deleteMedia(id) {
            try {
                const response = await api.delete(`${apiUrls.media}/${id}`);
                await this.fetchMedia();
            } catch (error) {
            }
        },
        async addMedia(
            media = {title, description, file}
        ) {
            try {
                await api.post(apiUrls.media, media, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });

                await reloadMedia();
                notification.success({message: `Media Added`});
                return true;
            } catch (error) {
                return false;
            }
        },
        async updateMedia(
            mediaId,
            media = {title, description, file}
        ) {
            try {
                await api.post(
                    `${apiUrls.media}/${mediaId}`,
                    {_method: "PATCH", ...media},
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );
                await reloadMedia();
                notification.success({message: "Media Updated successfully"});
                return true;
            } catch (error) {
                return false;
            }
        },

        async bulkDelete(ids = []) {
            if (!ids.length) return false;

            try {
                // Send array of IDs to backend
                await api.delete(`${apiUrls.media}/bulk-delete`, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    data: { ids } // <-- Axios sends DELETE payload in `data`
                });

                // Refresh media list
                await this.fetchMedia();

                notification.success({
                    message: `Deleted ${ids.length} media item(s)`
                });

                return true;
            } catch (error) {
                notification.error({
                    message: "Bulk delete failed"
                });
                return false;
            }
        }

    }

});